import { useState, useEffect } from 'react';
import { Avatar, Box, Fab, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { FormatListNumbered } from '@mui/icons-material';
import { getUltimosMedicamentos } from '../../services/Busquedas/Medicamentos';

export const UltimosMedicamentos = ({
  idAfiliado = null,
  limit = 10,
  onSelectEvent = null,
  soloAmbulatorios = false,
  soloPlanesEspeciales = false,
}) => {
  const [latestOption, setLatestOption] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    getLatestOptions();
  }, [idAfiliado]);

  const getLatestOptions = async () => {
    let query = `?limit=${limit}`;
    if (idAfiliado) {
      query = query + `&idAfiliado=${idAfiliado}`;
    }

    if (soloAmbulatorios) {
      query = query + `&soloAmbulatorios=${soloAmbulatorios}`;
    }

    if (soloPlanesEspeciales) {
      query = query + `&soloPlanesEspeciales=${soloPlanesEspeciales}`;
    }

    const result = await getUltimosMedicamentos(query);
    if (result.length > 0) {
      setLatestOption(result);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onHandleSelect = (cie10) => {
    setAnchorEl(null);
    if (onSelectEvent) {
      onSelectEvent(cie10);
    }
  };

  return (
    <>
      <Box
        sx={{
          height: { sm: '100%' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Tooltip title='Últimos medicamentos recetados'>
          <Fab
            onClick={handleClick}
            size='small'
            color='default'
            sx={{ boxShadow: 'none' }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={open ? 'true' : undefined}
          >
            <FormatListNumbered fontSize='small' color='primary' />
          </Fab>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id='account-menu'
        open={open}
        onClose={handleClose}
        onClick={handleClose}
      >
        {latestOption.map((medicamento) => (
          <MenuItem key={medicamento.registro} onClick={(e) => onHandleSelect(medicamento)}>
            ({medicamento.drogas}) {medicamento.nombre} ({medicamento.presentacion})
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
